<template>
    <p>Invalid Input:  
        <slot></slot>
    </p>
</template>
<style scoped>
p {
    color: rgb(207, 201, 201);
}
</style>